import { render, staticRenderFns } from "./taxes-insurance-index.vue?vue&type=template&id=1d10e3c1"
import script from "./taxes-insurance-index.vue?vue&type=script&lang=js"
export * from "./taxes-insurance-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports